// /app/frontend/src/data/communities.js

export const COMMUNITY_REGIONS = [
  {
    key: "africa",
    title: "Africa",
    blurb: "Across the continent — diaspora roots, modern connections.",
    countries: [
      "Algeria","Angola","Benin","Botswana","Burkina Faso","Burundi","Cabo Verde","Cameroon",
      "Central African Republic","Chad","Comoros","Congo (Republic)","Congo (DRC)","Djibouti",
      "Egypt","Equatorial Guinea","Eritrea","Eswatini","Ethiopia","Gabon","Gambia","Ghana",
      "Guinea","Guinea-Bissau","Ivory Coast (Côte d'Ivoire)","Kenya","Lesotho","Liberia","Libya",
      "Madagascar","Malawi","Mali","Mauritania","Mauritius","Morocco","Mozambique","Namibia",
      "Niger","Nigeria","Rwanda","São Tomé & Príncipe","Senegal","Seychelles","Sierra Leone",
      "Somalia","South Africa","South Sudan","Sudan","Tanzania","Togo","Tunisia","Uganda",
      "Zambia","Zimbabwe"
    ],
  },
  {
    key: "caribbean",
    title: "Caribbean",
    blurb: "Island nations + Caribbean territories with deep diaspora ties.",
    countries: [
      "Anguilla","Antigua & Barbuda","Aruba","Bahamas","Barbados","Bermuda","British Virgin Islands",
      "Cayman Islands","Cuba","Curaçao","Dominica","Dominican Republic","Grenada","Guadeloupe",
      "Haiti","Jamaica","Martinique","Montserrat","Puerto Rico","Saint Barthélemy",
      "Saint Kitts & Nevis","Saint Lucia","Saint Martin","Saint Vincent & the Grenadines",
      "Sint Maarten","Trinidad & Tobago","Turks & Caicos Islands","U.S. Virgin Islands"
    ],
  },
  {
    key: "south_america",
    title: "South America",
    blurb: "Afro-Latin communities, coastal heritage, and the wider diaspora.",
    countries: [
      "Argentina","Bolivia","Brazil","Chile","Colombia","Ecuador","Falkland Islands",
      "French Guiana","Guyana","Paraguay","Peru","Suriname","Uruguay","Venezuela"
    ],
  },
  {
    key: "central_america",
    title: "Central America",
    blurb: "From Garifuna roots to modern diaspora across the region.",
    countries: [
      "Belize","Costa Rica","El Salvador","Guatemala","Honduras","Nicaragua","Panama"
    ],
  },
  {
    key: "north_america",
    title: "North America",
    blurb: "U.S. + Canada + Mexico — and everyone connected to them.",
    countries: [
      "Canada","Mexico","United States"
    ],
  },
  {
    key: "europe",
    title: "Europe",
    blurb: "Diaspora communities across Europe and the UK.",
    countries: [
      "Albania","Andorra","Austria","Belarus","Belgium","Bosnia & Herzegovina","Bulgaria",
      "Croatia","Cyprus","Czechia","Denmark","Estonia","Finland","France","Germany","Greece",
      "Hungary","Iceland","Ireland","Italy","Kosovo","Latvia","Liechtenstein","Lithuania",
      "Luxembourg","Malta","Moldova","Monaco","Montenegro","Netherlands","North Macedonia",
      "Norway","Poland","Portugal","Romania","Russia","San Marino","Serbia","Slovakia",
      "Slovenia","Spain","Sweden","Switzerland","Ukraine","United Kingdom","Vatican City"
    ],
  },
  {
    key: "middle_east",
    title: "Middle East & North Africa Diaspora (MENA)",
    blurb: "Included — especially where diaspora communities live and travel.",
    countries: [
      "Bahrain","Iran","Iraq","Israel","Jordan","Kuwait","Lebanon","Oman",
      "Palestine","Qatar","Saudi Arabia","Syria","United Arab Emirates","Yemen"
    ],
  },
  {
    key: "oceania",
    title: "Oceania",
    blurb: "Diaspora communities in Australia, NZ, and the Pacific.",
    countries: [
      "Australia","Fiji","French Polynesia","Guam","Kiribati","Marshall Islands",
      "Micronesia","Nauru","New Caledonia","New Zealand","Northern Mariana Islands",
      "Palau","Papua New Guinea","Samoa","Solomon Islands","Tonga","Tuvalu",
      "Vanuatu"
    ],
  },
];

export const COMMUNITY_NOTE = {
  title: "Worldwide inclusion",
  body:
    "UnityLove is built for the African diaspora — but anyone who respects the culture and community can join. " +
    "If you don't see your country listed, you're still welcome. We'll keep expanding regional events over time."
};
